<script lang="ts" setup>
import { onMounted } from 'vue';
import { DgrDialog } from '@stockmarkteam/donguri-ui';
import { userSession } from '@/utils/userSession';

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const hideModal = () => {
  emit('close');
  return true;
};

onMounted(async () => {
  userSession.setIsShownTranslateNotification();
});
</script>

<template>
  <DgrDialog
    :open="true"
    title="海外メディアの記事配信について"
    :close-interceptor-handler="hideModal"
    :has-footer="false"
  >
    <template #description>
      <div class="modal-body">
        <div class="c-text-regular--m">
          海外メディアの記事についてはタイトルが自動で日本語に翻訳されて表示されます。<br />
          翻訳がされていない状態で表示したい場合は
          <router-link
            :to="{ name: 'userSettingsNews' }"
            custom
            v-slot="{ href, navigate }"
          >
            <a
              :href="href"
              @click="
                event => {
                  hideModal();
                  navigate(event);
                }
              "
              class="c-textLink c-textLink--underbar"
            >
              マイページの設定
            </a>
          </router-link>
          より変更が可能です。
        </div>
      </div>
    </template>
  </DgrDialog>
</template>

<style lang="scss" scoped>
.modal-body {
  width: 448px; /* 480 - padding * 2 */
}
</style>
